export const ACTIVE_STATUS_ID: number = 2
export const DECLINED_STATUS_ID: number = 4
